const Strangeluv = require('../../strangeluv-core');

const createWebpackContext = () => import.meta.webpackContext('../', {
    recursive: true,
    regExp: /^(?!.*(?:__tests__|\.spec|\.test)\.js$).*\.js$/
});

const wiring = module.exports = new Strangeluv(createWebpackContext());

if (module.hot) {
    // Rebuild the sync reducers list
    module.hot.accept('./reducers.js', () => wiring.flushReducers());
}
